import { identidadeGeneroRecord, sexoRecord } from 'types/enums'

import { BuscaCidadaoQueryResultModel } from '../../model/lista-tematica/model-acompanhamentoCondicaoSaudeListaTematica'

export const formatSexoIdentidadeGeneroRacaCor = ({
  sexoCidadao,
  identidadeGeneroCidadao,
  racaCorCidadao,
}: Pick<BuscaCidadaoQueryResultModel, 'sexoCidadao' | 'identidadeGeneroCidadao' | 'racaCorCidadao'>) => {
  const values = [
    sexoRecord[sexoCidadao],
    identidadeGeneroRecord[identidadeGeneroCidadao],
    racaCorCidadao?.capitalize(),
  ].filter(Boolean)

  return values.isNotEmpty() ? values.join(' | ') : '-'
}
